import { Suspense } from "react";
import * as React from "react";
import { useEffect } from "react";
import "./BuildingDetail.css";
import { Grid } from "@mui/material";
import Image from "mui-image";
import building from "src/img/building.png";
import ButtonPolicy from "src/components/Permission/ButtonPolicy";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import { useParams } from "react-router-dom";
import Paper from "@mui/material/Paper";
import BuildingForm from "src/components/BuildingDetails/BuildingForm";
import AssetForm from "src/components/AssetDetails/AssetForm";
import { useAlertContext } from "src/hooks/use-alert";
import { getBuilding } from "src/apis/complex";
import DeleteIcon from "@mui/icons-material/Delete";
import ConfigureAsset from "../../components/Asset2dImage/configureAsset";
import {
  useNavigate,
  useRouteLoaderData,
  defer,
  Await,
} from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { deleteAsset, dissociateAsset } from "src/apis/complex";
import { useState } from "react";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import { styled } from "@mui/material/styles";
import DailogContainer from "src/components/DailogContainer";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { CreateNewAssetImg } from "src/apis/ConfigureAsset3d";
import ArchilogicMapComponent from "../../components/ArchilogicMap/ArchilogicMaps";
import ErrorPage from "src/pages/ErrorPages/ErrorPage";
const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(20),
    border: "1px solid #dadde9",
  },
}));

export default function BuildingOne() {
  const roles = useAlertContext();
  const alert = useAlertContext();
  const { buildingId } = useParams();
  const data = useRouteLoaderData("building-detail");
  const navigate = useNavigate();
  const [deleteDetailOpen, setDeleteDetailOpen] = useState(false);
  const [deleteBuildingId, setDeleteBuildingId] = useState("");
  const [deleteAssetId, setDeleteAssetId] = useState("");
  const [deleteText, setDeleteText] = useState("");
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  {/**_______States and functions for 2d Asset image Configuration__________ */}
  const [openConfigureAsset, setOpenConfigureAsset] = useState(false);
  const [selectedAsset, setSelectedAsset] = useState(null);
  const [configurationApiData, setConfigurationApiData] = useState(null);
 {/** api call warpper for sending 2d image of asset */}
  const handleSubmitConfiguration = async (body) => {
    if (body) {
      try {
        const response = await CreateNewAssetImg(body);
        handleCloseConfigure()
        if (response.success) {
          console.log("success");
          console.log("Image Mapping SuccessFul");

          alert.setSuccess((prev) => [
            ...prev,
            {
              status: true,
              message: "Asset image creation successful",
              index: prev.length,
            },
          ]);
         
        } else {
          alert.setError((prev) => [
            ...prev,
            { status: true, messages: response.errors, index: prev.length },
          ]);
        }
      } catch (error) {
        alert.setError((prev) => [
          ...prev,
          { status: true, messages: error.message, index: prev.length },
        ]);
        handleCloseConfigure()
      }
    }
  };

 {/** feed asset to dialog for configuring asset 2d image and open dialog */}
  const handleClickOpenConfigure = (asset) => {
    setSelectedAsset(asset);
    setOpenConfigureAsset(true);
  };

  {/** close dialog */}
  const handleCloseConfigure = () => {
    setOpenConfigureAsset(false);
  };
  
{/**_______End of 2d Asset image Configuration__________ */}

  const ViewMoreDetails = (id) => {
    navigate(`asset/${id}`)
  }
  useEffect(() => {
    const storedImage = localStorage.getItem("uploadedImage");
    if (storedImage) {
      setPreviewImage(storedImage);
    }
  }, []);

  const handleDelete = (loadedbuilding, row) => {
    if (row.items.length > 0) {
      alert.setError((prev) => [
        ...prev,
        {
          status: true,
          message:
            "Cannot delete " +
            row.name +
            " because it has " +
            row.items.length +
            " items in it.",
        },
      ]);
    } else {
      setDeleteDetailOpen(true);
      setDeleteBuildingId(loadedbuilding.id);
      setDeleteAssetId(row.id);
      setDeleteText("Are you sure you want to delete this asset?");
    }
  };

  // Callback function to confirm the delete in child component
  const handleConfirmChange = () => {
    handleConfirmDeleteRow();
  };

  const handleConfirmDeleteRow = async () => {
    const building = [deleteBuildingId];
    const resp = await dissociateAsset({
      id: deleteAssetId,
      buildings: building,
    });
    const response = await deleteAsset(deleteAssetId);
    if (response.success) {
      console.log("success");
      setAssets((prevAssets) =>
        prevAssets.filter((asset) => asset.id !== deleteAssetId)
      );
      console.log("Updated assets:", assets);

      alert.setSuccess((prev) => [
        ...prev,
        {
          status: true,
          message: "Asset deleted succesfully",
          index: prev.length,
        },
      ]);
    } else {
      alert.setError((prev) => [
        ...prev,
        { status: true, messages: response.errors, index: prev.length },
      ]);
    }
    setDeleteDetailOpen(false);
  };

  const [modal, setModal] = useState({ open: false, formElement: null });
  const [externalSubmit, setExternalSubmit] = useState(false);
  const [assets, setAssets] = useState([]);

  useEffect(() => {
    var buildingAssets;
    if (data.building && data.building.site.buildings) {
      buildingAssets = data.building.site.buildings.find(
        (building) => building.id === parseInt(buildingId)
      )?.assets;
      if (buildingAssets) {
        setAssets(buildingAssets);
        console.log("Initial assets:", buildingAssets);
      }
    }
   
  }, [data.building, buildingId]);

  const handleExternalSubmit = (submitting, closeModal = false) => {
    if (submitting) {
      setExternalSubmit(true);
    } else {
      if (closeModal) {
        handleClose();
        navigate();
      }
      setExternalSubmit(false);
    }
  };

  const handleClickOpen = (form) => {
    setModal({ open: true, formElement: form });
  };

  const handleClose = () => {
    setModal({ open: false, formElement: null });
  };

  const [open, setOpen] = useState(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };

  {/**___ Section for uploading image of building___**/}
  // Step 1: Create state variables for image handling
  const [selectedImage, setSelectedImage] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);

  // Step 2: Handle the file change event
  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedImage(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);

        // Convert the image to a Base64 string and store it in local storage
        localStorage.setItem("uploadedImage", reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <Suspense
      fallback={
        <p style={{ color: "#FFF", textAlign: "center" }}>Loading...</p>
      }
    >
      <Await resolve={data.building} errorElement={<ErrorPage />}>
        {(loadedbuilding) => (
          <>
           {loadedbuilding ? (
          <div>
            <div className="started">
              <h2>{loadedbuilding.name}</h2>
            </div>
            <div className="directory">
              Inventory: {loadedbuilding.site.name} - {loadedbuilding.name}
            </div>
            <div className="homeContainerBuilding">
              <Grid container>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                 <ArchilogicMapComponent buildingAssets={assets}/>

                  <div className="buildInfoBuilding">
                    <div className="buildImageBuilding">
                      <ClickAwayListener onClickAway={handleTooltipClose}>
                        <div>
                          <HtmlTooltip
                            PopperProps={{
                              disablePortal: true,
                            }}
                            onClose={handleTooltipClose}
                            open={open}
                            disableFocusListener
                            disableHoverListener
                            disableTouchListener
                            title={
                              <React.Fragment>
                                <Typography color="inherit">
                                  <ButtonPolicy>Change</ButtonPolicy>
                                </Typography>
                              </React.Fragment>
                            }
                          ></HtmlTooltip>
                        </div>
                      </ClickAwayListener>
                    </div>
                  </div>
                </Grid>
                <Grid item lg={6} md={6} sm={12} sx={12}>
                  <div className="info">
                    <Grid container>
                      <Grid item md={6} lg={6} sm={6} xs={6}>
                        <div className="infoTitle">
                          <h2>Info</h2>
                        </div>
                      </Grid>
                      <Grid item md={6} lg={6} sm={6} xs={6}>
                        <div className="infoButton">
                          <ButtonPolicy
                            //disabled={roles.roles === 'bpu'}
                            onClick={() => handleClickOpen("building")}
                            variant="contained"
                            sx={{
                              width: 150,
                              borderRadius: "0",
                            }}
                          >
                            Update Building
                          </ButtonPolicy>
                        </div>
                      </Grid>
                      <Grid item md={12} lg={12} sm={12} xs={12}>
                        <div className="description">
                          <Grid container>
                            <Grid item lg={6} md={6} sm={12} xs={12}>
                              <div className="detailsItem">
                                <span className="titleItem">Name: </span>
                                {loadedbuilding.name}
                              </div>
                            </Grid>
                            <Grid item lg={6} md={6} sm={12} xs={12}>
                              <div className="detailsItem">
                                <span className="titleItem">Address: </span>
                                {loadedbuilding.site.address}
                              </div>
                            </Grid>
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <div className="detailsItem desc">
                                <span className="titleItem">Description:</span>
                                <div className="description-details">
                                  {loadedbuilding.description}
                                </div>
                              </div>
                            </Grid>
                          </Grid>
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                  <div className="assets">
                    <Grid container>
                      <Grid item md={6} lg={6} sm={6} xs={6}>
                        <div className="infoTitle">
                          <h2>Assets</h2>
                        </div>
                      </Grid>
                      <Grid item md={6} lg={6} sm={6} xs={6}>
                        <div className="infoButton">
                          <ButtonPolicy
                            onClick={() => handleClickOpen("asset")}
                            //disabled={roles.roles !== 'adm'}
                            variant="contained"
                            sx={{
                              width: 150,
                              borderRadius: "0",
                            }}
                          >
                            Add Asset
                          </ButtonPolicy>
                        </div>
                      </Grid>
                      <Grid item md={12} lg={12} sm={12} xs={12}>
                        <div className="tableContainer">
                          <TableContainer component={Paper}>
                            <Table>
                              <TableBody>
                                {assets.map((row) => (
                                  <TableRow
                                    key={row.id === undefined ? row : row.id}
                                  >
                                    <TableCell>{row.name}</TableCell>
                                    <TableCell>{row.address}</TableCell>
                                    <TableCell>
                                      <div className="viewMore">
                                        <ButtonPolicy
                                          onClick={() =>
                                            handleClickOpenConfigure(row)
                                          }
                                          variant="contained"
                                          color="primary"
                                        >
                                          Configure Asset
                                        </ButtonPolicy>
                                      </div>
                                    </TableCell>
                                    <TableCell>
                                      <div className="viewMore">
                                        <ButtonPolicy
                                          onClick={() =>
                                            // navigate(`asset/${row.id}`)
                                            ViewMoreDetails(row.id)
                                          }
                                          variant="contained"
                                          color="primary"
                                        >
                                          View More
                                        </ButtonPolicy>
                                      </div>
                                    </TableCell>
                                    <TableCell>
                                      <div className="deleteButton">
                                        <ButtonPolicy
                                          variant="contained"
                                          color="secondary"
                                          //disabled={roles.roles !== 'adm'}

                                          onClick={() =>
                                            handleDelete(loadedbuilding, row)
                                          }
                                        >
                                          <DeleteIcon />
                                        </ButtonPolicy>
                                      </div>
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </div>
                      </Grid>
                      <Grid>
                        <div className="monitor">
                          <ButtonPolicy
                            onClick={() =>
                              navigate(
                                `/dashboard/monitoring/site/${loadedbuilding.site.id}`
                              )
                            }
                            variant="contained"
                            sx={{
                              width: 300,
                              borderRadius: "0",
                            }}
                          >
                            Monitoring
                          </ButtonPolicy>
                          <div className="circle">!</div>
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                </Grid>
              </Grid>
              <Dialog open={modal.open} onClose={handleClose}>
                <div className="modalContainer">
                  <div className="modal">
                    <Grid container spacing={3}>
                      <Grid item md={12} xs={12}>
                        <DialogContent>
                          <Grid container>
                            {modal.formElement === "building" ? (
                              <BuildingForm
                                props={{
                                  custom: true,
                                  onSubmit: handleExternalSubmit,
                                  externalSubmit: externalSubmit,
                                  building: loadedbuilding,
                                  siteData: {
                                    id: loadedbuilding.site.id,
                                    name: loadedbuilding.site.name,
                                  },
                                }}
                              />
                            ) : (
                              <AssetForm
                                props={{
                                  custom: true,
                                  onSubmit: handleExternalSubmit,
                                  externalSubmit: externalSubmit,
                                  buildingData: {
                                    id: loadedbuilding.id,
                                    name: loadedbuilding.name,
                                  },
                                }}
                              />
                            )}
                          </Grid>
                        </DialogContent>
                      </Grid>
                      <Grid item md={12} xs={12}>
                        <div className="bottomPart">
                          <DialogActions>
                            <Grid container>
                              <Grid item xs={6} md={6}>
                                <div className="cancelUPdateBuilding">
                                  <ButtonPolicy
                                  className="cancelUPdateBuilding"
                                    onClick={() => handleClose()}
                                    variant="text"
                                  >
                                    Cancel
                                  </ButtonPolicy>
                                </div>
                              </Grid>
                              <Grid item xs={6} md={6}>
                                <div className="addButton">
                                  <ButtonPolicy
                                    variant="text"
                                    onClick={() => handleExternalSubmit(true)}
                                  >
                                    {/* <ButtonPolicy variant="text"> */}
                                    submit
                                  </ButtonPolicy>
                                </div>
                              </Grid>
                            </Grid>
                          </DialogActions>
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                </div>
              </Dialog>
              {selectedAsset && (
                <Dialog
                  open={openConfigureAsset}
                  onClose={handleCloseConfigure}
                  fullScreen
                >
                  <div className="modalContainer">
                    <div className="modal">
                      <DialogContent>
                        <ConfigureAsset
                          configurationData={selectedAsset}
                          setApiBody={setConfigurationApiData}
                        />
                      </DialogContent>
                      <DialogActions>
                        <Grid container>
                          <Grid item xs={10} md={10}></Grid>
                          <Grid item xs={1} md={1}>
                            <div className="cancelButton">
                              <ButtonPolicy
                                variant="text"
                                onClick={handleCloseConfigure}
                              >
                                Cancel
                              </ButtonPolicy>
                            </div>
                          </Grid>
                          <Grid item xs={1} md={1}>
                            <div className="addButton">
                              <ButtonPolicy
                                variant="text"
                                onClick={() =>
                                  handleSubmitConfiguration(
                                    configurationApiData
                                  )
                                }
                              >
                                submit
                              </ButtonPolicy>
                            </div>
                          </Grid>
                        </Grid>
                      </DialogActions>
                    </div>
                  </div>
                </Dialog>
              )}
            </div>
            {deleteDetailOpen && (
              <DailogContainer
                detailOpen={deleteDetailOpen}
                setDetailOpen={setDeleteDetailOpen}
                text={deleteText}
                onToggleChange={handleConfirmChange}
              />
            )}
            
          </div>
           ):(
            <ErrorPage />
          )}
          </>
        )}
      </Await>
    </Suspense>
  );
}

async function loadBuilding(id) {
  const response = await getBuilding(id);
  return response;
}

async function DeleteAsset(id) {
  const response = await deleteAsset(id);
  return response.data.response[0];
}

export async function loader({ request, params }) {
  const id = params.buildingId;

  return defer({
    building: await loadBuilding(id),
  });
}
